export default "__VITE_ASSET__BVL2Z2qq__"